import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const ActionIconButton = ({
  id,
  keyValue,
  tooltipText,
  icon,
  disabled = false,
  dataCount,
  className,
  onClick
}) => {
  return (
    <OverlayTrigger
      key={keyValue}
      placement="top"
      overlay={<Tooltip className="custom-tooltip">{tooltipText}</Tooltip>}
    >
      <button
        id={id}
        onClick={onClick}
        disabled={disabled}
        data-count={dataCount ?? undefined}
        className={`btn grid-icon-btn info-icon-btn ${className}`}
      >
        <FontAwesomeIcon icon={icon} />
      </button>
    </OverlayTrigger>
  );
};

ActionIconButton.propTypes = {
  id: PropTypes.string,
  keyValue: PropTypes.string,
  tooltipText: PropTypes.string,
  icon: PropTypes.object,
  disabled: PropTypes.bool,
  dataCount: PropTypes.number,
  className: PropTypes.string,
  onClick: PropTypes.func
};

export default ActionIconButton;
